import React, { Component } from 'react'
import g, { Span } from 'glamorous'
import moment from 'moment';
import Swiper from 'react-id-swiper'
import 'react-id-swiper/src/styles/css/swiper.css'

import TeamInDate from './team-in-date-fragm'
import CardViews from './card-views-fragm'

import './styles/index.scss'

import LazyLoad from 'react-lazyload';

import DFPAdsProvider from '@univision/fe-commons/dist/components/ads/dfp/DFPAdsProvider';
import DFPAd from '@univision/fe-commons/dist/components/ads/dfp/DFPAd';
import BKPIndicator from '@univision/fe-commons/dist/components/breakpoint/BreakPointIndicator';


import { pageData } from '../../config/advertising';

import adHelper from '@univision/fe-commons/dist/utils/ads/adHelper';
import AdSettings from '@univision/fe-commons/dist/utils/ads/adSettings.json';
import * as AdTypes from '@univision/fe-commons/dist/utils/ads/ad-types';


class GroupView extends Component {

    constructor(props) {
      super(props)    
    }

    set_content_type()  
	{
		try {
			utag.content_type = "slideshow";
			utag.primary_tag = "Calendario Mundial Rusia 2018";
		}catch(errr){}
	}
	track_click($tag_name)
	{
		this.set_content_type();
		try {
			
			utag.link({ 
				event : 'engagement', 
				promo_type : 'other', 
				promo_loc : 'http://www.univision.com/calendario-y-horarios-del-mundial-de-rusia-2018', 
				promo_name : $tag_name
			});
		} catch (errr) { }
	}

    componentDidMount() {        
        const currentMatch = this.getOneMatchById(this.props.currentMatchId)
        this.selectGroup(`GRUPO${currentMatch.groupId}`)
    }
    callDFPAd = (type, index) => {
        const adSettings = AdSettings[AdTypes[type]];
        const settings = adHelper.getSettings(adSettings);

        
        if(index == 4){
            return (
                <div style={{ "textAlign": "center" }}>
                  <BKPIndicator />
                  <g.Div className="container-advertising">
                    <DFPAdsProvider
                        env={pageData.env}
                        settings={pageData.data.adSettings}
                        requestParams={pageData.requestParams}
                        contentType={pageData.data.type}
                    >
                        <DFPAd {...settings}  />
                    </DFPAdsProvider>
                  </g.Div>
                </div>
              );
        }
        else {
            return (
                <div></div>
            );
        }
    };
    isMobile () {
        return {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
            }
        };
    }

	selectGroup = (id, ev?) => {
        if (ev) ev.preventDefault();
        // if(!this.isMobile().any()) return;
		var $items = document.getElementsByClassName("uvn-fifa2018-group-view-item");
        
		for (let i = 0; i < $items.length; i++) {
			var element = $items[i];
			element.classList.remove("uvn-fifa2018-group-view-item-selected");
			
			if(element.id == id)
			{
				element.classList.add('uvn-fifa2018-group-view-item-selected');
                /*setTimeout(() => {
                    let sumSticky = (this.isMobile().any()) ? (element.offsetTop - 71 - 30) : (element.offsetTop - 63 - 50)
                    window.scrollTo(0,sumSticky);
                    console.log({
                        "element.offsetTop": element.offsetTop,
                        sumSticky: sumSticky,
                        element: element
                    });
                    
                }, 200);*/
                if (ev) {
                    let matchelements = element.getElementsByClassName("matchitem");
                    if (matchelements.length > 0) {
                        this.props.gotomatch(matchelements[0].dataset.matchid)
                        
                    }
                }

                break;
			}
		}
	}

    getTeamsByGroupId(groupId) {
        const { teams } = this.props.nodes.data.matchSchedule;
        return teams.filter(tm => tm.group.id === groupId).sort((a, b) => (a.group.position - b.group.position))
    }

    getMatchsByGroupIdAndDateId(groupId, dateId) {
        const { matchs } = this.props.nodes.data.matchSchedule
        return matchs.filter(mt => mt.dateId === dateId && mt.groupId === groupId)
    }

    getOneTeamByGroupIdAndPosition(groupId, positionId) {
        const { teams } = this.props.nodes.data.matchSchedule;
        let rteams = teams.filter(tm => tm.group.id === groupId && tm.group.position === positionId)
        return rteams.length > 0 ? rteams[rteams.length - 1] : 
        { 
            id: 9999, 
            flag: 'default.png', 
            isoalph3: groupId+positionId, 
            name: groupId+positionId,
            "player": {
                "name": "",
                "earnings": 0,
                "pic": "default.png"
            },
            "food": {
                "name": "",
                "calories": 0,
                "pic": "default.png"
            },
            "beverage": {
                "name": "",
                "alcoholProof": 0,
                "pic": "default.png"
            }
        }
    }

    getOneMatchById(matchId) {
        const { matchs } = this.props.nodes.data.matchSchedule
        let rmatchs = matchs.filter(mt => mt.id === parseInt(matchId, 0))
        return rmatchs.length > 0 ? rmatchs[rmatchs.length - 1] : null
    }

    getOneStadiumById(stadiumId) {
        const { stadiums } = this.props.nodes.data.matchSchedule
        let rstadiums = stadiums.filter(st => st.id === stadiumId)
        return rstadiums.length > 0 ? rstadiums[rstadiums.length - 1] : null
    }

    formatUTCMatchDate(datetimeUTC, format) {
        return moment(parseInt(datetimeUTC, 0)).format(format)
    }

	render() {          
        const { groups, dates, defaults } = this.props.nodes.data.matchSchedule
        const currentMatch = this.getOneMatchById(this.props.currentMatchId)
        const currentLeftTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.leftTeam.groupId, currentMatch.leftTeam.position)
        const currentRightTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.rightTeam.groupId, currentMatch.rightTeam.position)
        const currentStadium = this.getOneStadiumById(currentMatch.stadiumId)
        return (
            <g.Div className="uvn-fifa2018-group-view">               
                <g.Ul>
                    {
                        groups.map((gr, grk) => {
                            //className="uvn-wc-advertising"
                            return (
                                
                                <g.Li key={grk} id={`GRUPO${gr.id}`}  className={`uvn-fifa2018-group-view-item ${ grk == 4 ? ` uvn-wc-advertising`: `` }`}>
                                    <LazyLoad > 
                                        {this.callDFPAd("TOP_AD", grk)}
                                    </LazyLoad>    
                                    <g.Div className="container-teams-name">
                                        <g.Div
                                            className="name"
                                            onClick={(e) => this.selectGroup('GRUPO'+gr.id, e)}>
                                            <g.Span>{gr.name}</g.Span>
                                            <g.H2 display="none">{gr.name}</g.H2>
                                            <g.Img src="data:image/svg+xml,%3Csvg%20width%3D%2215px%22%20height%3D%2210px%22%20viewBox%3D%220%200%2015%2010%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2047.1%20%2845422%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Page-2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Calendario_mobile_grupos_tragosver2nueva%22%20transform%3D%22translate%28-189.000000%2C%20-690.000000%29%22%20stroke-width%3D%222%22%20stroke%3D%22%23292929%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-7-Copy%22%20transform%3D%22translate%285.000000%2C%20684.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-4%22%20transform%3D%22translate%28113.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path-2%22%20transform%3D%22translate%2878.363961%2C%206.363961%29%20scale%281%2C%20-1%29%20rotate%28-135.000000%29%20translate%28-78.363961%2C%20-6.363961%29%20%22%20points%3D%2282.863961%201.86396103%2082.863961%2010.863961%2073.863961%2010.863961%22%3E%3C/polyline%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E" className="arr-down" />
                                            <g.Img src="data:image/svg+xml,%3Csvg%20width%3D%2215px%22%20height%3D%2210px%22%20viewBox%3D%220%200%2015%2010%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2047.1%20%2845422%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Page-2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Calendario_mobile_grupos_tragosver2nueva%22%20transform%3D%22translate%28-187.000000%2C%20-309.000000%29%22%20stroke-width%3D%222%22%20stroke%3D%22%23292929%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-4%22%20transform%3D%22translate%28119.000000%2C%20304.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path-2%22%20transform%3D%22translate%2875.500000%2C%2013.500000%29%20rotate%28-135.000000%29%20translate%28-75.500000%2C%20-13.500000%29%20%22%20points%3D%2280%209%2080%2018%2071%2018%22%3E%3C/polyline%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E" className="arr-up" />
                                        </g.Div>
                                        <g.Div className="teams" onClick={(e) => this.selectGroup('GRUPO'+gr.id, e)}>
                                            <g.Ul>
                                                {
                                                    this.getTeamsByGroupId(gr.id).map((tm, tmk) => {
                                                        return (<g.Li key={tmk}>
                                                                    <g.Img src={require(`./images/flags/${tm.flag}`)} className="flag-team" />
                                                                    <g.Span className="name-team-short">{tm.isoalph3}</g.Span>
                                                                    <g.Span className="name-team-large">{tm.name}</g.Span>
                                                                    <g.H3 display="none">{tm.name}</g.H3>
                                                                </g.Li>)
                                                    })
                                                }
                                            </g.Ul>
                                        </g.Div>
                                    </g.Div>
                                    <g.Div className="dates">
                                        <g.Ul>
                                            {
                                                dates.map((dt, dtk) => {
                                                    return (
                                                        <g.Li key={dtk}>
                                                            <g.Div className="title-date">{dt.name}</g.Div>
                                                            <g.H2 display="none">{dt.name}</g.H2>
                                                            <g.Ul className="list-dates">
                                                                {
                                                                    this.getMatchsByGroupIdAndDateId(gr.id, dt.id).map((mt, mtk) => {
                                                                        return (
                                                                            <g.Li key={mtk}
                                                                                  cursor="pointer"
                                                                                  innerRef={(el) => { if (el) el.dataset.matchid = mt.id }}
                                                                                  className={['matchitem', mt.id === currentMatch.id ? 'selected' : ''].join(' ')}
                                                                                  onClick={() => {
                                                                                      this.track_click('CalendarioRusia2018Card'); 
                                                                                      this.props.gotomatch(mt.id);
                                                                                  }}>
                                                                                <g.Div className="content-info-date">
                                                                                    <g.Div className="date-string">{this.formatUTCMatchDate(mt.datetimeUTC, 'DD/MM/YYYY')}</g.Div>
                                                                                    <g.H3 display="none">{this.getOneTeamByGroupIdAndPosition(mt.leftTeam.groupId, mt.leftTeam.position).name} VS {this.getOneTeamByGroupIdAndPosition(mt.rightTeam.groupId, mt.rightTeam.position).name}</g.H3>
                                                                                    <TeamInDate
                                                                                        className="team-left"                                                                                        
                                                                                        team={this.getOneTeamByGroupIdAndPosition(mt.leftTeam.groupId, mt.leftTeam.position)} />
                                                                                    <g.Div className="vs">VS</g.Div>
                                                                                    <TeamInDate
                                                                                        className="team-right"
                                                                                        team={this.getOneTeamByGroupIdAndPosition(mt.rightTeam.groupId, mt.rightTeam.position)} />
                                                                                </g.Div>
                                                                            </g.Li>
                                                                        )
                                                                    })
                                                                }
                                                            </g.Ul>
                                                        </g.Li>
                                                    )
                                                })
                                            }
                                        </g.Ul>
                                    </g.Div>
                                    {
                                        (currentMatch !== null && currentMatch.groupId === gr.id) &&                                        
                                        <CardViews
                                            currentLeftTeam={currentLeftTeam}
                                            currentRightTeam={currentRightTeam}
                                            currentMatch={currentMatch}
                                            defaults={defaults}
                                            currentStadium={currentStadium}
                                            cardIndex={this.props.cardIndex}
                                            gotocard={this.props.gotocard} 
                                            emphasysCard={this.props.emphasysCard}/>
                                    }
                                </g.Li>
                            )
                        })
                    }
                </g.Ul>
			</g.Div>)
	}
}

export default GroupView


// WEBPACK FOOTER //
// ./src/components/calendar/group-view.js